export default __webpack_public_path__ + "static/media/22.c3e68f52.jpg";